<template>
  <el-main>
    <header-actions>
      <template
        slot="left-side"
        v-if="widgets.length && widgets.length > pageSize"
      >
        <el-pagination
          ref="paginator"
          style="line-height:normal !important;"
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          :total="widgets.length"
          @current-change="handlePaginate"
        />
      </template>
      <template slot="middle-side">
        <el-input
          v-model="$store.state.shared_customers_widgets_list.filter_string"
          size="small"
          spa-action="find"
        />
      </template>
      <template slot="button-group">
        <el-checkbox
          :value="!!count_selected"
          :class="partSelectedClass"
          @change="handleSelectAllClick"
          >{{ count_selected ? count_selected + "/" + widgets.length : "" }}
        </el-checkbox>
        <el-select size="small" v-model="selected_vendor">
          <el-option
            v-for="v in vendors"
            :key="v.uuid"
            :label="v.name"
            :value="v.uuid"
          />
        </el-select>
        <span>
          <el-button
            type="primary"
            size="small"
            :disabled="!selected_vendor || !count_selected"
            icon="el-icon-paperclip"
            @click="handleLinkWithVendor"
          />
        </span>
      </template>
    </header-actions>
    <br />
    <card
      v-for="w in widgets.slice(pageOffset, pageOffset + pageSize)"
      :key="w.uuid"
      :amo-widget="w"
    />
    <div v-if="widgets.length && widgets.length > pageSize">
      <el-pagination
        ref="paginator"
        style="line-height:normal !important;"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="widgets.length"
        @current-change="handlePaginate"
      />
    </div>
  </el-main>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import HeaderActions from "../_snippets/header_actions/header_actions";
import Card from "./elements/card";

export default {
  name: "widgets_list",
  components: { Card, HeaderActions },
  data() {
    return {
      pageSize: 10,
      pageOffset: 0,
      currentPage: 1,
      selected_vendor: ""
    };
  },
  created() {
    this.getData();
    this.getVendors();
  },
  beforeRouteLeave(to, from, next) {
    this.resetState();
    next();
  },
  watch: {
    "$store.state.shared_customers_widgets_list.filter_string"(v) {
      this.currentPage = 1;
      this.pageOffset = 0;
    },
    "$route.query.amo_uuid"(v) {
      this.getData();
    }
  },
  methods: {
    ...mapMutations({
      resetState: "shared_customers_widgets_list/resetState"
    }),
    ...mapActions({
      getVendors: "directory_vendors_list/getData",
      getData: "shared_customers_widgets_list/getData",
      linkSelectedWidgetsWithVendor:
        "shared_customers_widgets_list/linkSelectedWidgetsWithVendor"
    }),
    handlePaginate() {
      this.pageOffset = (arguments[0] - 1) * this.pageSize;
    },
    handleSelectAllClick() {
      let selected = this.count_selected !== this.widgets.length;
      this.widgets.forEach(v => {
        v._selected = selected;
      });
    },
    handleLinkWithVendor() {
      let data = this.widgets.reduce((r, v) => {
        if (v._selected) {
          r.push({
            uuid: v.uuid,
            "directory-vendors_uuid": this.selected_vendor
          });
        }
        return r;
      }, []);

      !data.length || this.linkSelectedWidgetsWithVendor({ data: data });
    }
  },
  computed: {
    widgets() {
      let amo_uuid = this.$route.query.amo_uuid;
      return this.$store.getters["shared_customers_widgets_list/widgets"](
        amo_uuid
      );
    },
    ...mapGetters("directory_vendors_list", ["vendors"]),
    ...mapState("shared_customers_widgets_list", ["count_selected"]),
    partSelectedClass() {
      return {
        "part-selected":
          this.count_selected !== 0 &&
          this.count_selected !== this.widgets.length
      };
    }
  }
};
</script>

<style lang="stylus">
.part-selected
    & .el-checkbox__inner
        background-color #DCDFE6 !important
        border-color #DCDFE6 !important
</style>
